import React from "react";
import { Skeleton } from "@heroui/skeleton";

export default function SideMenuSkeleton() {
  return (
    <div className="side-navbar rounded-lg flex flex-col md:flex-row ">
      {/* Sidebar Skeleton */}
      <div className="hidden md:block md:w-1/5 min-w-[220px] sticky top-24 h-screen overflow-y-auto">
        {[...Array(1)].map((_, index) => (
          <Skeleton key={index} className="h-400 w-full mb-4 rounded-lg" />
        ))}
      </div>
    </div>
  );
}
